import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const useSchema = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      yup.object().shape({
        password: yup
          .string()
          .oneOf([yup.ref('confirmPassword'), null], t('common.form.validation.passwordsMustMatch'))
          .required(t('common.form.validation.required')),
        confirmPassword: yup
          .string()
          .oneOf([yup.ref('password'), null], t('common.form.validation.passwordsMustMatch'))
          .required(t('common.form.validation.required')),
      }),
    [t],
  );
};

export default useSchema;
